import type { DefaultTranslationsObject, Language } from '../types.js'

export const zhTwTranslations: DefaultTranslationsObject = {
  authentication: {
    account: '帳戶',
    accountOfCurrentUser: '目前使用者的帳戶',
    accountVerified: '帳戶驗證成功。',
    alreadyActivated: '已啟用',
    alreadyLoggedIn: '已登入',
    apiKey: 'API 金鑰',
    authenticated: '已驗證',
    backToLogin: '返回登入',
    beginCreateFirstUser: '請先建立第一位使用者。',
    changePassword: '變更密碼',
    checkYourEmailForPasswordReset:
      '如果這個電子郵件地址有對應的帳戶，您將會收到重設密碼的說明。請檢查垃圾郵件或垃圾郵件匣以免錯過郵件。',
    confirmGeneration: '確認產生',
    confirmPassword: '確認密碼',
    createFirstUser: '建立第一位使用者',
    emailNotValid: '提供的電子郵件無效',
    emailOrUsername: '電子郵件或使用者名稱',
    emailSent: '電子郵件已寄出',
    emailVerified: '電子郵件驗證成功。',
    enableAPIKey: '啟用 API 金鑰',
    failedToUnlock: '解除鎖定失敗',
    forceUnlock: '強制解除鎖定',
    forgotPassword: '忘記密碼',
    forgotPasswordEmailInstructions: '請輸入您的電子郵件。您將會收到一封包含密碼重設指示的郵件。',
    forgotPasswordQuestion: '忘記密碼？',
    forgotPasswordUsernameInstructions:
      '請輸入您的使用者名稱。重設密碼的指示將會寄送至該帳號所綁定的電子郵件。',
    generate: '產生',
    generateNewAPIKey: '產生新的 API 金鑰',
    generatingNewAPIKeyWillInvalidate:
      '產生新的 API 金鑰將會使原本的金鑰<1>失效</1>。確定要繼續嗎？',
    lockUntil: '鎖定至',
    logBackIn: '重新登入',
    loggedIn: '若要使用其他使用者登入，請先<0>登出</0>。',
    loggedInChangePassword: '若要變更密碼，請前往<0>帳戶</0>設定進行修改。',
    loggedOutInactivity: '由於閒置過久，您已被自動登出。',
    loggedOutSuccessfully: '您已成功登出。',
    loggingOut: '登出中…',
    login: '登入',
    loginAttempts: '登入嘗試次數',
    loginUser: '登入使用者',
    loginWithAnotherUser: '若要使用其他使用者登入，請先<0>登出</0>。',
    logOut: '登出',
    logout: '登出',
    logoutSuccessful: '成功登出。',
    logoutUser: '登出使用者',
    newAccountCreated:
      '已為您建立新帳戶，可前往 <a href="{{serverURL}}">{{serverURL}}</a> 登入。請點選以下連結或將網址貼到瀏覽器以完成電子郵件驗證：<a href="{{verificationURL}}">{{verificationURL}}</a><br>完成驗證後即可成功登入。',
    newAPIKeyGenerated: '已產生新的 API 金鑰。',
    newPassword: '新密碼',
    passed: '驗證通過',
    passwordResetSuccessfully: '密碼重設成功。',
    resetPassword: '重設密碼',
    resetPasswordExpiration: '密碼重設有效期限',
    resetPasswordToken: '密碼重設憑證',
    resetYourPassword: '重設您的密碼',
    stayLoggedIn: '維持登入狀態',
    successfullyRegisteredFirstUser: '已成功註冊第一位使用者。',
    successfullyUnlocked: '已成功解除鎖定',
    tokenRefreshSuccessful: '存取權杖更新成功。',
    unableToVerify: '無法驗證',
    username: '使用者名稱',
    usernameNotValid: '提供的使用者名稱無效',
    verified: '已驗證',
    verifiedSuccessfully: '成功驗證',
    verify: '驗證',
    verifyUser: '驗證使用者',
    verifyYourEmail: '請驗證您的電子郵件',
    youAreInactive:
      '您已有一段時間沒有操作系統，為了您的帳戶安全，系統即將自動登出。是否要維持登入狀態？',
    youAreReceivingResetPassword:
      '您會收到這封郵件是因為您（或其他人）請求重設此帳戶的密碼。請點選以下連結，或將該連結貼至瀏覽器以完成操作：',
    youDidNotRequestPassword: '如果這不是您本人操作，請忽略這封郵件，您的密碼將不會改變。',
  },
  dashboard: {
    addButton: '添加 +',
    addWidget: '添加小工具',
    deleteWidget: '刪除小工具 {{id}}',
    discardConfirmLabel: '丟棄',
    discardMessage: '您的儀表板佈局有未保存的更改。您確定要放棄它們嗎？',
    discardTitle: '放棄變更？',
    editDashboard: '編輯儀表板',
    editingDashboard: '編輯儀表板',
    noItems: '您的儀表板上沒有小工具。您可以從頂部工具欄中的"儀表板"選單添加它們。',
    resetLayout: '重設版面配置',
    searchWidgets: '搜索小工具...',
  },
  error: {
    accountAlreadyActivated: '此帳戶已啟用。',
    autosaving: '自動儲存文件時發生問題。',
    correctInvalidFields: '請修正無效欄位。',
    deletingFile: '刪除檔案時發生錯誤。',
    deletingTitle: '刪除 {{title}} 時發生錯誤。請檢查網路連線後再試一次。',
    documentNotFound: '找不到 ID 為 {{id}} 的文件。可能已被刪除、不存在，或您沒有權限存取。',
    emailOrPasswordIncorrect: '電子郵件或密碼錯誤。',
    failedToResetLayout: '無法重設版面配置。',
    failedToSaveLayout: '保存布局失败。',
    followingFieldsInvalid_one: '以下欄位無效：',
    followingFieldsInvalid_other: '以下欄位無效：',
    incorrectCollection: '集合不正確',
    insufficientClipboardPermissions: '無法存取剪貼簿。請確認您的剪貼簿權限。',
    invalidClipboardData: '剪貼簿資料無效。',
    invalidFileType: '不支援的檔案類型',
    invalidFileTypeValue: '檔案類型無效：{{value}}',
    invalidRequestArgs: '請求中傳入的參數無效：{{args}}',
    loadingDocument: '載入 ID 為 {{id}} 的文件時發生問題。',
    localesNotSaved_one: '以下語言地區無法儲存：',
    localesNotSaved_other: '以下語言地區無法儲存：',
    logoutFailed: '登出失敗。',
    missingEmail: '缺少電子郵件。',
    missingIDOfDocument: '缺少要更新之文件的 ID。',
    missingIDOfVersion: '缺少版本 ID。',
    missingRequiredData: '缺少必要資料。',
    noFilesUploaded: '尚未上傳任何檔案。',
    noMatchedField: '找不到對應欄位：「{{label}}」',
    notAllowedToAccessPage: '您沒有權限存取此頁面。',
    notAllowedToPerformAction: '您沒有執行此操作的權限。',
    notFound: '找不到所請求的資源。',
    noUser: '找不到使用者',
    previewing: '預覽文件時發生問題。',
    problemUploadingFile: '上傳檔案時發生問題。',
    restoringTitle: '還原 {{title}} 時發生錯誤。請檢查連線並再試一次。',
    revertingDocument: '在還原此文件時出現了問題。',
    tokenInvalidOrExpired: '憑證無效或已過期。',
    tokenNotProvided: '未提供憑證。',
    unableToCopy: '無法複製。',
    unableToDeleteCount: '無法刪除 {{total}} 個 {{label}} 中的 {{count}} 個。',
    unableToReindexCollection: '重新索引集合 {{collection}} 時發生錯誤。作業已中止。',
    unableToUpdateCount: '無法更新 {{total}} 個 {{label}} 中的 {{count}} 個。',
    unauthorized: '未經授權，您必須先登入才能執行此請求。',
    unauthorizedAdmin: '未授權，該使用者無法存取管理後台。',
    unknown: '發生未知錯誤。',
    unPublishingDocument: '取消發佈文件時發生問題。',
    unspecific: '發生錯誤。',
    unverifiedEmail: '請先完成電子郵件驗證後再登入。',
    userEmailAlreadyRegistered: '該電子郵件已註冊為使用者帳號。',
    userLocked: '此使用者因登入失敗次數過多而被鎖定。',
    usernameAlreadyRegistered: '該使用者名稱已被註冊。',
    usernameOrPasswordIncorrect: '使用者名稱或密碼錯誤。',
    valueMustBeUnique: '此欄位的值必須是唯一的',
    verificationTokenInvalid: '驗證憑證無效。',
  },
  fields: {
    addLabel: '新增 {{label}}',
    addLink: '新增連結',
    addNew: '新增',
    addNewLabel: '新增 {{label}}',
    addRelationship: '新增關聯',
    addUpload: '新增上傳',
    block: '區塊',
    blocks: '區塊',
    blockType: '區塊類型',
    chooseBetweenCustomTextOrDocument: '選擇輸入自訂文字網址，或連結到其他文件。',
    chooseDocumentToLink: '選擇要連結的文件',
    chooseFromExisting: '從現有項目中選擇',
    chooseLabel: '選擇 {{label}}',
    collapseAll: '全部收合',
    customURL: '自訂網址',
    editLabelData: '編輯 {{label}} 資料',
    editLink: '編輯連結',
    editRelationship: '編輯關聯',
    enterURL: '輸入網址',
    internalLink: '內部連結',
    itemsAndMore: '{{items}} 及另外 {{count}} 項',
    labelRelationship: '{{label}} 關聯',
    latitude: '緯度',
    linkedTo: '已連結至 <0>{{label}}</0>',
    linkType: '連結類型',
    longitude: '經度',
    newLabel: '新增 {{label}}',
    openInNewTab: '在新分頁中開啟',
    passwordsDoNotMatch: '密碼不一致。',
    relatedDocument: '相關文件',
    relationTo: '關聯對象',
    removeRelationship: '移除關聯',
    removeUpload: '移除上傳項目',
    saveChanges: '儲存變更',
    searchForBlock: '搜尋區塊',
    searchForLanguage: '搜索語言',
    selectExistingLabel: '選取現有 {{label}}',
    selectFieldsToEdit: '選取要編輯的欄位',
    showAll: '全部展開',
    swapRelationship: '交換關聯',
    swapUpload: '交換上傳項目',
    textToDisplay: '顯示文字',
    toggleBlock: '切換區塊',
    uploadNewLabel: '上傳新 {{label}}',
  },
  folder: {
    browseByFolder: '依資料夾瀏覽',
    byFolder: '依資料夾',
    deleteFolder: '刪除資料夾',
    folderName: '資料夾名稱',
    folders: '資料夾',
    folderTypeDescription: '選取此資料夾中允許存放哪種類型的集合文件。',
    itemHasBeenMoved: '{{title}} 已移至 {{folderName}}',
    itemHasBeenMovedToRoot: '{{title}} 已移至根資料夾',
    itemsMovedToFolder: '{{title}} 已移至 {{folderName}}',
    itemsMovedToRoot: '{{title}} 已移至根資料夾',
    moveFolder: '移動資料夾',
    moveItemsToFolderConfirmation:
      '您即將移動 <1>{{count}} 個 {{label}}</1> 到 <2>{{toFolder}}</2>。確定要繼續？',
    moveItemsToRootConfirmation:
      '您即將移動 <1>{{count}} 個 {{label}}</1> 到根資料夾。確定要繼續？',
    moveItemToFolderConfirmation:
      '您即將移動 <1>{{title}}</1> 到 <2>{{toFolder}}</2>。確定要繼續？',
    moveItemToRootConfirmation: '您即將移動 <1>{{title}}</1> 到根資料夾。確定要繼續？',
    movingFromFolder: '正在從 {{fromFolder}} 移動 {{title}}',
    newFolder: '新增資料夾',
    noFolder: '無資料夾',
    renameFolder: '重新命名資料夾',
    searchByNameInFolder: '在 {{folderName}} 中依名稱搜尋',
    selectFolderForItem: '為 {{title}} 選取資料夾',
  },
  general: {
    name: '名稱',
    aboutToDelete: '您即將刪除 {{label}} <1>{{title}}</1>。確定要繼續？',
    aboutToDeleteCount_many: '您即將刪除 {{count}} 個 {{label}}',
    aboutToDeleteCount_one: '您即將刪除 {{count}} 個 {{label}}',
    aboutToDeleteCount_other: '您即將刪除 {{count}} 個 {{label}}',
    aboutToPermanentlyDelete: '您即將永久刪除 {{label}} <1>{{title}}</1>。確定要繼續？',
    aboutToPermanentlyDeleteTrash:
      '您即將從垃圾桶中永久刪除 <0>{{count}}</0> 個 <1>{{label}}</1>。確定要繼續？',
    aboutToRestore: '您即將還原 {{label}} <1>{{title}}</1>。確定要繼續？',
    aboutToRestoreAsDraft: '您即將以草稿狀態還原 {{label}} <1>{{title}}</1>。確定要繼續？',
    aboutToRestoreAsDraftCount: '您即將還原 {{count}} 個 {{label}} 為草稿',
    aboutToRestoreCount: '您即將還原 {{count}} 個 {{label}}',
    aboutToTrash: '您即將將 {{label}} <1>{{title}}</1> 移至垃圾桶。確定要繼續？',
    aboutToTrashCount: '您即將將 {{count}} 個 {{label}} 移至垃圾桶',
    addBelow: '在下方新增',
    addFilter: '新增篩選條件',
    adminTheme: '管理主題',
    all: '全部',
    allCollections: '所有集合',
    allLocales: '所有語言地區',
    and: '與',
    anotherUser: '其他使用者',
    anotherUserTakenOver: '其他使用者已接手編輯此文件。',
    applyChanges: '套用變更',
    ascending: '遞增',
    automatic: '自動',
    backToDashboard: '返回儀表板',
    cancel: '取消',
    changesNotSaved: '變更尚未儲存。若您現在離開，將會遺失所有變更。',
    clear: '清除',
    clearAll: '全部清除',
    close: '關閉',
    collapse: '收合',
    collections: '集合',
    columns: '欄',
    columnToSort: '排序欄位',
    confirm: '確認',
    confirmCopy: '確認複製',
    confirmDeletion: '確認刪除',
    confirmDuplication: '確認複製',
    confirmMove: '確認移動',
    confirmReindex: '重新索引 {{collections}}？',
    confirmReindexAll: '重新索引所有集合？',
    confirmReindexDescription: '此操作將移除現有索引，並重新索引 {{collections}} 集合中的文件。',
    confirmReindexDescriptionAll: '此操作將移除所有索引，並重新索引所有集合中的文件。',
    confirmRestoration: '確認還原',
    copied: '已複製',
    copy: '複製',
    copyField: '複製欄位',
    copying: '複製中',
    copyRow: '複製列',
    copyWarning: '您即將使用 {{from}} 覆寫 {{label}} {{title}} 中的 {{to}}。確定要繼續？',
    create: '建立',
    created: '已建立',
    createdAt: '建立時間',
    createNew: '建立新項目',
    createNewLabel: '建立新的 {{label}}',
    creating: '建立中',
    creatingNewLabel: '正在建立新的 {{label}}',
    currentlyEditing:
      '目前正在編輯此文件。若您接手，對方將無法繼續編輯，且未儲存的變更可能會遺失。',
    custom: '自訂',
    dark: '深色',
    dashboard: '儀表板',
    delete: '刪除',
    deleted: '已刪除',
    deletedAt: '刪除時間',
    deletedCountSuccessfully: '已成功刪除 {{count}} 個 {{label}}。',
    deletedSuccessfully: '刪除成功。',
    deleteLabel: '刪除 {{label}}',
    deletePermanently: '略過垃圾桶並永久刪除',
    deleting: '刪除中…',
    depth: '層級',
    descending: '遞減',
    deselectAllRows: '取消全選列',
    document: '文件',
    documentIsTrashed: '此 {{label}} 已移至垃圾桶，僅供讀取。',
    documentLocked: '文件已鎖定',
    documentModified: '已修改的文件',
    documentOutOfDate: '這份文件最近被另一位使用者更新。您的視圖已過期。',
    documents: '文件',
    duplicate: '複製',
    duplicateWithoutSaving: '不儲存變更直接複製',
    edit: '編輯',
    editAll: '全部編輯',
    editedSince: '上次編輯時間',
    editing: '編輯中',
    editingLabel_many: '正在編輯 {{count}} 個 {{label}}',
    editingLabel_one: '正在編輯 {{count}} 個 {{label}}',
    editingLabel_other: '正在編輯 {{count}} 個 {{label}}',
    editingTakenOver: '編輯權已被接手',
    editLabel: '編輯 {{label}}',
    email: '電子郵件',
    emailAddress: '電子郵件地址',
    emptyTrash: '清空垃圾桶',
    emptyTrashLabel: '清空 {{label}} 垃圾桶',
    enterAValue: '請輸入數值',
    error: '錯誤',
    errors: '錯誤',
    exitLivePreview: '離開即時預覽',
    export: '匯出',
    fallbackToDefaultLocale: '回復至預設語言',
    false: '否',
    filter: '篩選',
    filters: '篩選條件',
    filterWhere: '篩選 {{label}}，條件為',
    globals: '全域',
    goBack: '返回',
    groupByLabel: '依 {{label}} 分組',
    import: '匯入',
    isEditing: '正在編輯中',
    item: '項目',
    items: '項目',
    language: '語言',
    lastModified: '最後修改時間',
    layout: '版面配置',
    leaveAnyway: '仍要離開',
    leaveWithoutSaving: '離開且不儲存',
    light: '淺色',
    livePreview: '即時預覽',
    loading: '載入中',
    locale: '語言地區',
    locales: '語言地區',
    lock: '鎖定',
    menu: '選單',
    moreOptions: '更多選項',
    move: '移動',
    moveConfirm: '您即將移動 {{count}} 個 {{label}} 至 <1>{{destination}}</1>。確定要繼續？',
    moveCount: '移動 {{count}} 個 {{label}}',
    moveDown: '下移',
    moveUp: '上移',
    moving: '移動中',
    movingCount: '正在移動 {{count}} 個 {{label}}',
    newLabel: '新的 {{label}}',
    newPassword: '新密碼',
    next: '下一頁',
    no: '否',
    noDateSelected: '尚未選取日期',
    noFiltersSet: '尚未設定篩選條件',
    noLabel: '<無 {{label}}>',
    none: '無',
    noOptions: '無選項',
    noResults: '找不到符合條件的 {{label}}。可能尚未建立或篩選條件不符。',
    noResultsDescription: '或者是不存在，或者是都不符合您上面指定的過濾條件。',
    noResultsFound: '沒有結果。',
    notFound: '找不到',
    nothingFound: '查無資料',
    noTrashResults: '{{label}} 垃圾桶為空。',
    noUpcomingEventsScheduled: '沒有即將到來的事件。',
    noValue: '無值',
    of: '之',
    only: '僅限',
    open: '開啟',
    or: '或',
    order: '順序',
    overwriteExistingData: '覆寫現有欄位資料',
    pageNotFound: '找不到此頁面',
    password: '密碼',
    pasteField: '貼上欄位',
    pasteRow: '貼上列',
    payloadSettings: 'Payload 設定',
    permanentlyDelete: '永久刪除',
    permanentlyDeletedCountSuccessfully: '已成功永久刪除 {{count}} 個 {{label}}。',
    perPage: '每頁顯示：{{limit}}',
    previous: '上一頁',
    reindex: '重新索引',
    reindexingAll: '正在重新索引 {{collections}}。',
    reloadDocument: '重新載入文件',
    remove: '移除',
    rename: '重新命名',
    reset: '重設',
    resetPreferences: '重設偏好設定',
    resetPreferencesDescription: '此操作會將所有偏好設定恢復為預設值。',
    resettingPreferences: '正在重設偏好設定。',
    restore: '還原',
    restoreAsPublished: '還原為已發佈版本',
    restoredCountSuccessfully: '已成功還原 {{count}} 個 {{label}}。',
    restoring: '還原中…',
    row: '列',
    rows: '列',
    save: '儲存',
    saveChanges: '保存更改',
    saving: '儲存中…',
    schedulePublishFor: '排程發佈 {{title}}',
    searchBy: '依 {{label}} 搜尋',
    select: '選取',
    selectAll: '選取全部 {{count}} 個 {{label}}',
    selectAllRows: '選取所有列',
    selectedCount: '已選取 {{count}} 個 {{label}}',
    selectLabel: '選取 {{label}}',
    selectValue: '請選取一個值',
    showAllLabel: '顯示所有 {{label}}',
    sorryNotFound: '很抱歉，找不到符合條件的內容。',
    sort: '排序',
    sortByLabelDirection: '依 {{label}} {{direction}} 排序',
    stayOnThisPage: '留在此頁面',
    submissionSuccessful: '送出成功。',
    submit: '送出',
    submitting: '送出中…',
    success: '成功',
    successfullyCreated: '已成功建立 {{label}}。',
    successfullyDuplicated: '已成功複製 {{label}}。',
    successfullyReindexed:
      '已成功重新索引 {{count}} 個來自 {{collections}} 的 {{total}} 個文件，並跳過了 {{skips}} 個草稿。',
    takeOver: '接手編輯',
    thisLanguage: '中文（繁體）',
    time: '時間',
    timezone: '時區',
    titleDeleted: '{{label}}「{{title}}」已成功刪除。',
    titleRestored: '{{label}}「{{title}}」已成功還原。',
    titleTrashed: '{{label}}「{{title}}」已移至垃圾桶。',
    trash: '垃圾桶',
    trashedCountSuccessfully: '{{count}} 個 {{label}} 已移至垃圾桶。',
    true: '是',
    unauthorized: '未經授權',
    unlock: '解鎖',
    unsavedChanges: '您有尚未儲存的變更。請先儲存或捨棄後再繼續。',
    unsavedChangesDuplicate: '您有尚未儲存的變更。是否仍要繼續複製？',
    untitled: '未命名',
    upcomingEvents: '即將到來的事件',
    updatedAt: '更新時間',
    updatedCountSuccessfully: '已成功更新 {{count}} 個 {{label}}。',
    updatedLabelSuccessfully: '已成功更新 {{label}}。',
    updatedSuccessfully: '更新成功。',
    updateForEveryone: '為所有人更新',
    updating: '更新中',
    uploading: '上傳中',
    uploadingBulk: '正在上傳 {{current}} / {{total}}',
    user: '使用者',
    username: '使用者名稱',
    users: '使用者',
    value: '值',
    viewing: '檢視中',
    viewReadOnly: '唯讀檢視',
    welcome: '歡迎',
    yes: '是',
  },
  localization: {
    cannotCopySameLocale: '無法複製到相同語言地區',
    copyFrom: '複製來源',
    copyFromTo: '從 {{from}} 複製到 {{to}}',
    copyTo: '複製到',
    copyToLocale: '複製至語言地區',
    localeToPublish: '要發佈的語言地區',
    selectedLocales: '選擇的地區設定',
    selectLocaleToCopy: '選取要複製的語言地區',
    selectLocaleToDuplicate: '選擇要複製的地區設定',
  },
  operators: {
    contains: '包含',
    equals: '等於',
    exists: '存在',
    intersects: '相交',
    isGreaterThan: '大於',
    isGreaterThanOrEqualTo: '大於或等於',
    isIn: '屬於',
    isLessThan: '小於',
    isLessThanOrEqualTo: '小於或等於',
    isLike: '類似',
    isNotEqualTo: '不等於',
    isNotIn: '不屬於',
    isNotLike: '不類似',
    near: '接近',
    within: '範圍內',
  },
  upload: {
    addFile: '新增檔案',
    addFiles: '新增多個檔案',
    bulkUpload: '大量上傳',
    crop: '裁剪',
    cropToolDescription: '拖曳選取區域的角落、重新繪製區域或調整下方數值以進行裁剪。',
    download: '下載',
    dragAndDrop: '拖放檔案',
    dragAndDropHere: '或將檔案拖放到此處',
    editImage: '編輯圖片',
    fileName: '檔案名稱',
    fileSize: '檔案大小',
    filesToUpload: '待上傳的檔案',
    fileToUpload: '待上傳的檔案',
    focalPoint: '對焦點',
    focalPointDescription: '直接在預覽圖上拖曳以設定對焦點，或調整下方數值。',
    height: '高度',
    lessInfo: '顯示較少資訊',
    moreInfo: '顯示更多資訊',
    noFile: '無檔案',
    pasteURL: '貼上網址',
    previewSizes: '預覽尺寸',
    selectCollectionToBrowse: '選取要瀏覽的集合',
    selectFile: '選取檔案',
    setCropArea: '設定裁剪區域',
    setFocalPoint: '設定對焦點',
    sizes: '尺寸',
    sizesFor: '{{label}} 的尺寸',
    width: '寬度',
  },
  validation: {
    emailAddress: '請輸入有效的電子郵件地址。',
    enterNumber: '請輸入有效的數字。',
    fieldHasNo: '此欄位沒有 {{label}}',
    greaterThanMax: '{{value}} 超過允許的最大 {{label}} 值 {{max}}。',
    invalidBlock: '該區塊 "{{block}}" 是不被允許的。',
    invalidBlocks: '此欄位包含已不再允許的區塊：{{blocks}}。',
    invalidInput: '此欄位的輸入無效。',
    invalidSelection: '此欄位的選取項目無效。',
    invalidSelections: '此欄位包含以下無效選項：',
    latitudeOutOfBounds: '緯度必須在 -90 和 90 之間。',
    lessThanMin: '{{value}} 低於允許的最小 {{label}} 值 {{min}}。',
    limitReached: '已達上限，最多只能新增 {{max}} 個項目。',
    longerThanMin: '此值必須超過最小長度 {{minLength}} 個字元。',
    longitudeOutOfBounds: '經度必須介於 -180 和 180 之間。',
    notValidDate: '「{{value}}」不是有效的日期格式。',
    required: '此欄位為必填項目。',
    requiresAtLeast: '此欄位至少需要 {{count}} 個 {{label}}。',
    requiresNoMoreThan: '此欄位最多只能有 {{count}} 個 {{label}}。',
    requiresTwoNumbers: '此欄位需包含兩個數字。',
    shorterThanMax: '此值必須少於最大長度 {{maxLength}} 個字元。',
    timezoneRequired: '請選取一個時區。',
    trueOrFalse: '此欄位只能為 true 或 false。',
    username: '請輸入有效的使用者名稱。可包含英文字母、數字、連字號、句點與底線。',
    validUploadID: '此欄位不是有效的上傳 ID。',
  },
  version: {
    type: '類型',
    aboutToPublishSelection: '您即將發佈所有選取的 {{label}}。確定要繼續？',
    aboutToRestore: '您即將將此 {{label}} 文件還原至 {{versionDate}} 的狀態。',
    aboutToRestoreGlobal: '您即將將全域 {{label}} 還原至 {{versionDate}} 的狀態。',
    aboutToRevertToPublished: '您即將還原此文件至已發佈狀態。確定要繼續？',
    aboutToUnpublish: '您即將取消發佈此文件。確定要繼續？',
    aboutToUnpublishIn: '您即將在{{locale}}中取消發佈此文件。你確定嗎？',
    aboutToUnpublishSelection: '您即將取消發佈所有選取的 {{label}}。確定要繼續？',
    autosave: '自動儲存',
    autosavedSuccessfully: '已成功自動儲存。',
    autosavedVersion: '自動儲存版本',
    changed: '已變更',
    changedFieldsCount_one: '{{count}} 個欄位已變更',
    changedFieldsCount_other: '{{count}} 個欄位已變更',
    compareVersion: '比較以下版本：',
    compareVersions: '比較版本',
    comparingAgainst: '正在與下列版本比較',
    confirmPublish: '確認發佈',
    confirmRevertToSaved: '確認還原為已儲存版本',
    confirmUnpublish: '確認取消發佈',
    confirmVersionRestoration: '確認還原此版本',
    currentDocumentStatus: '目前為 {{docStatus}} 文件',
    currentDraft: '目前草稿',
    currentlyPublished: '目前已發佈',
    currentlyViewing: '目前檢視',
    currentPublishedVersion: '目前已發佈版本',
    draft: '草稿',
    draftHasPublishedVersion: '草稿（有已發佈版本）',
    draftSavedSuccessfully: '草稿已成功儲存。',
    lastSavedAgo: '上次儲存時間：{{distance}} 前',
    modifiedOnly: '僅顯示已變更的內容',
    moreVersions: '更多版本…',
    noFurtherVersionsFound: '找不到更多版本',
    noLabelGroup: '未命名群組',
    noRowsFound: '找不到 {{label}}',
    noRowsSelected: '尚未選取任何 {{label}}',
    preview: '預覽',
    previouslyDraft: '先前為草稿',
    previouslyPublished: '先前已發佈',
    previousVersion: '前一版本',
    problemRestoringVersion: '還原此版本時發生問題',
    publish: '發佈',
    publishAllLocales: '發佈所有語言版本',
    publishChanges: '發佈變更',
    published: '已發佈',
    publishIn: '發佈於 {{locale}}',
    publishing: '發佈中',
    restoreAsDraft: '還原為草稿',
    restoredSuccessfully: '還原成功。',
    restoreThisVersion: '回復此版本',
    restoring: '還原中…',
    reverting: '還原中…',
    revertToPublished: '還原至已發佈版本',
    revertUnsuccessful: '還原失敗。找不到先前已發布的版本。',
    saveDraft: '儲存草稿',
    scheduledSuccessfully: '排程成功。',
    schedulePublish: '排程發佈',
    selectLocales: '選擇要顯示的語言版本',
    selectVersionToCompare: '選擇要比較的版本',
    showingVersionsFor: '顯示版本：',
    showLocales: '顯示語言版本：',
    specificVersion: '指定版本',
    status: '狀態',
    unpublish: '取消發佈',
    unpublished: '未發佈',
    unpublishedSuccessfully: '成功取消發佈。',
    unpublishIn: '在{{locale}}中取消發佈',
    unpublishing: '取消發佈中…',
    version: '版本',
    versionAgo: '{{distance}} 前',
    versionCount_many: '找到 {{count}} 個版本',
    versionCount_none: '找不到版本',
    versionCount_one: '找到 {{count}} 個版本',
    versionCount_other: '找到 {{count}} 個版本',
    versionID: '版本 ID',
    versions: '版本記錄',
    viewingVersion: '正在檢視 {{entityLabel}}「{{documentTitle}}」的版本',
    viewingVersionGlobal: '正在檢視全域 {{entityLabel}} 的版本',
    viewingVersions: '正在檢視 {{entityLabel}}「{{documentTitle}}」的所有版本',
    viewingVersionsGlobal: '正在檢視全域 {{entityLabel}} 的所有版本',
  },
}

export const zhTw: Language = {
  dateFNSKey: 'zh-TW',
  translations: zhTwTranslations,
}
